<footer>
    <div class="footer-container">
    </div>
</footer>